import setBreakpoint from './setBreakpoint.js';
import getBreakpoint from './getBreakpoint.js';
export default {
  setBreakpoint,
  getBreakpoint
};


//////////////////
// WEBPACK FOOTER
// D:/Server/anglestudios_co/invicta-angle/wordpress/wp-content/themes/invicta/node_modules/swiper/core/breakpoints/index.js
// module id = 81
// module chunks = 0